import { config, library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faArrowAltCircleLeft,
    faCameraRetro,
    faCaretDown,
    faCaretRight,
    faClipboard,
    faEnvelope,
    faHistory,
    faInfoCircle,
    faLongArrowAltDown,
    faMinusCircle,
    faPlusCircle,
    faSearch,
    faTimesCircle
} from '@fortawesome/free-solid-svg-icons';

library.add(
    faArrowAltCircleLeft,
    faCameraRetro,
    faCaretDown,
    faCaretRight,
    faClipboard,
    faEnvelope,
    faHistory,
    faInfoCircle,
    faLongArrowAltDown,
    faMinusCircle,
    faPlusCircle,
    faSearch,
    faTimesCircle
);

config.autoAddCss = false;

import { createApp } from 'vue';
import App from '@/App.vue';
import pinia from "@/store.js";
import router from '@/router';

const app = createApp(App)

app.use(pinia);
app.use(router);

app.config.errorHandler = (err) => {
    console.log(err);
}

router.isReady().then(() => {
    app.mount('#app');
});

app.component('font-awesome-icon', FontAwesomeIcon);
